@if (mode === 'delete') {
  <ts-dialog [title]="dialogTitle" (closeDialog)="dialogRef.close(false)">
    <p ts-dialog-body>
      This task predecessor relationship with <span class="font-bold">{{ predecessorTitle }}</span> will be removed.
    </p>
    <div class="ts-dialog-actions-container" ts-dialog-actions>
      <ts-button
        variant="secondary"
        (click)="dialogRef.close(false)"
        [disabled]="disabled"
        [attr.data-testid]="'task-details-predecessor-cancel-button'"
        >Cancel</ts-button
      >
      <ts-button
        variant="danger"
        (click)="onPredecessorDeleted()"
        [disabled]="disabled"
        [attr.data-testid]="'task-details-predecessor-delete-button'"
        >Delete</ts-button
      >
    </div>
  </ts-dialog>
} @else {
  <ts-dialog [title]="dialogTitle" (closeDialog)="dialogRef.close(false)">
    <div ts-dialog-body>
      <form class="flex flex-col justify-center gap-2" [formGroup]="predecessorForm">
        <span class="flex flex-row items-center justify-between">
          <p>Task</p>
          @if (loadingTasks) {
            <ts-skeleton height="56"></ts-skeleton>
          } @else {
            <ts-select
              itemKey="id"
              itemLabel="title"
              formControlName="predecessor_task_id"
              class="w-1/2"
              [hasGroups]="false"
              [disabled]="disabled"
              [attr.data-testid]="'task-details-predecessor-task-select'"
              [uiOptions]="{
                roundedBorders: false,
                placeholder: 'Select a task',
                searchPlaceholder: 'Task title...',
                size: 'full',
              }"
              [items]="predecessorOptions"
            ></ts-select>
          }
        </span>

        <span class="flex flex-row items-center justify-between">
          <p>Type</p>
          <ts-select
            itemKey="slug"
            itemLabel="name"
            formControlName="predecessor_type"
            class="w-1/2"
            [disabled]="disabled"
            [attr.data-testid]="'task-details-predecessor-type-select'"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Select a type',
              searchPlaceholder: 'Predecessor type...',
              size: 'full',
            }"
            [items]="predecessorTypes"
          ></ts-select>
        </span>

        <span class="flex flex-row items-center justify-between">
          <p>Lag (Days)</p>
          <ts-input
            class="w-1/2"
            type="number"
            formControlName="lag"
            [roundedBorders]="false"
            [attr.data-testid]="'task-details-predecessor-lag-input'"
          ></ts-input>
        </span>

        <span class="flex flex-row items-center justify-between">
          <p>Lag Type</p>
          <ts-select
            itemKey="type"
            itemLabel="label"
            formControlName="lag_type"
            class="w-1/2"
            [disabled]="false"
            [attr.data-testid]="'task-details-predecessor-lag-type-select'"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Select a type',
              searchPlaceholder: 'Lag type...',
              size: 'full',
            }"
            [items]="lagTypes"
          ></ts-select>
        </span>
      </form>
    </div>

    <div class="ts-dialog-actions-container" ts-dialog-actions>
      <ts-button
        variant="secondary"
        (click)="dialogRef.close(false)"
        [disabled]="disabled"
        [attr.data-testid]="'task-details-predecessor-cancel-button'"
        >Cancel</ts-button
      >
      <ts-button
        attr.data-testid="task-details-predecessor-save-button"
        variant="primary"
        [disabled]="predecessorForm.invalid"
        (click)="onPredecessorChanged()"
        [disabled]="disabled"
        >{{ mode === 'add' ? 'Add' : 'Save' }}
      </ts-button>
    </div>
  </ts-dialog>
}
